// Single source of truth for planning session status — replaces the old
// PlanningSessionStatusEnum that lived here and PlanningSessionStatus in client.ts.
export enum PlanningSessionStatus {
    INITIATED = 'initiated',
    PROCESSING = 'processing',
    AWAITING_ANSWERS = 'awaiting_answers',
    PLAN_READY = 'plan_ready',
    FINALIZED = 'finalized',
    FAILED = 'failed',
    EXPIRED = 'expired'
}

// Keep the old name as an alias so existing imports still compile.
export { PlanningSessionStatus as PlanningSessionStatusEnum };

export const PlanningSessionStatusMap: Record<PlanningSessionStatus, string> = {
    [PlanningSessionStatus.INITIATED]: 'Initiated',
    [PlanningSessionStatus.PROCESSING]: 'Processing',
    [PlanningSessionStatus.AWAITING_ANSWERS]: 'Awaiting Answers',
    [PlanningSessionStatus.PLAN_READY]: 'Plan Ready',
    [PlanningSessionStatus.FINALIZED]: 'Finalized',
    [PlanningSessionStatus.FAILED]: 'Failed',
    [PlanningSessionStatus.EXPIRED]: 'Expired'
};

export interface PlanningSession {
    sessionId: string;
    initialDescription: string;
    created: string;
    status: PlanningSessionStatus;
}

export interface PlanningQuestionOption {
    value: string;
    label: string;
}

export interface PlanningQuestion {
    type: 'singleSelect' | 'multiSelect';
    question: string;
    options: PlanningQuestionOption[];
    questionPhase: 'product' | 'technical' | null;
}

export interface PlanningSessionData {
    sessionId: string;
    status: PlanningSessionStatus;
    questions: PlanningQuestion[] | null;
    plan: string | null;
    turnCount: number;
    questId: string | null;
    clarityScore: number | null;
}

export interface StartPlanningRequest {
    projectId: number;
    description: string;
    attachmentList?: number[];
    planningNeeded: boolean;
    status: number;
    priority?: number;
    questId?: string;
    alwaysHumanReview?: boolean;
}

export interface SubmitAnswerItem {
    questionId: string;
    selectedOptionIds: string[];
    freeText: string | null;
}

export interface SubmitAnswersRequest {
    answers: SubmitAnswerItem[];
}

export interface SubmitFeedbackRequest {
    feedback: string;
    attachmentList?: number[];
}

export interface EditPlanRequest {
    plan: string;
    attachmentList?: number[];
}

export interface FinalizePlanRequest {
    priority: number;
    status: number;
    alwaysHumanReview?: boolean;
}
